var {combineReducers} = require('redux')
var {reducer: formReducer} = require('redux-form')

module.exports = combineReducers({
  form: formReducer
})



/** WEBPACK FOOTER **
 ** C:/repos/react-examples/~/eslint-loader!C:/repos/react-examples/redux-form-components/reducers.js
 **/